/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { NumberFormatter } from './NumberFormatter.js';
/**
 * Signature of a ticks-format
 * * ticksIn - the ticks to be formatted
 * * ticksOut - must be filled with the formatted ticks
 * * locale - the locale to be used
 */

/**
 * Creates a {@link TicksFormat} for the given options.
 */
export function createTicksFormat(shorthandLabels, decimalPlaces) {
  const numberFormatter = new NumberFormatter(shorthandLabels, decimalPlaces);
  return (ticksIn, ticksOut, locale) => {
    for (let i = 0; i < ticksIn.length; i++) {
      ticksOut[i] = numberFormatter.format(ticksIn[i], locale);
    }
  };
}
